<template>
    <textarea ref="richText"></textarea>
</template>
<script>
import richTextConfig from "@/common/richTextConfig";

export  default  {
    data() {
        return {
            richTextId: ''
        }
    },
    mounted() {
        var el = this.$refs.richText
        tinymce.init({
            target: el,
            language:'zh_CN',
            height: 300,
            menubar: false,
            branding: false, // 隐藏右下角技术支持
            contextmenu_never_use_native: false, // 在编辑器中屏蔽浏览器本身的右键菜单
            convert_urls: false, // 图片带域名
            fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px',
            content_style: "img {max-width:100%;}",
            selector: 'textarea',
            plugins: 'link', // 只启用链接插件，不启用图像上传
            toolbar: 'undo redo | bold italic | link', // 仅保留需要的工具栏按钮
            // ...richTextConfig
        }).then((editors) => {
            this.richTextId = editors[0].id
            this.initBackCall()
        });
    },
    beforeDestroy() {
        tinymce.get(this.richTextId).destroy()
    },
    methods: {
        initBackCall() {
            this.$emit('initBackCall')
        },
        setContent(v) {
            setTimeout(() => {
                if (tinymce.get(this.richTextId)) {
                    tinymce.get(this.richTextId).setContent(v)
                }
            }, 500)
        },
        getContent() {
            return tinymce.get(this.richTextId).getContent()
        }
    }
}
</script>
<style>

</style>